import { render, staticRenderFns } from "./TaskViewStatusDispatcher.vue?vue&type=template&id=d34a0fd8&scoped=true&lang=pug&"
import script from "./TaskViewStatusDispatcher.vue?vue&type=script&lang=js&"
export * from "./TaskViewStatusDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34a0fd8",
  null
  
)

export default component.exports